import './AssignStep.scss'
import { Button } from '@mui/material'
import { LoadingButton } from 'components/mui'
import { useTrayStepContext } from '../AddTray.logic'
import TrayCaseDetails from 'components/organisms/TrayCaseDetails/TrayCaseDetails'
import { useAddTrayContext } from '../AddTray.context'
import { useState } from 'react'
import Modal from 'components/molecules/Modal/Modal'
import { Typography } from '@mui/material'

const AssignStep = () => {
  const { nextStep, prevStep } = useTrayStepContext()
  const { traySurgeryId, trays, setTraySurgeryId, setTraySurgery, setTrays } =
    useAddTrayContext()
  const [showWarningModal, setShowWarningModal] = useState(false)
  const [pendingSurgeryChange, setPendingSurgeryChange] = useState<{
    surgeryId: string
    surgery: any
  } | null>(null)

  const handleSurgeryChange = (surgeryId: string, surgery: any) => {
    // Only show warning if there are multiple trays
    if (trays.length > 1) {
      setPendingSurgeryChange({ surgeryId, surgery })
      setShowWarningModal(true)
    } else {
      // If only one tray, apply the change directly
      setTraySurgeryId(surgeryId)
      setTraySurgery(surgery)
    }
  }

  const confirmSurgeryChange = () => {
    if (pendingSurgeryChange) {
      setTraySurgeryId(pendingSurgeryChange.surgeryId)
      setTraySurgery(pendingSurgeryChange.surgery)
      setPendingSurgeryChange(null)
      setTrays(
        trays.map((tray) => ({
          ...tray,
          surgery: pendingSurgeryChange.surgery,
        }))
      )
    }
    setShowWarningModal(false)
  }

  const cancelSurgeryChange = () => {
    setPendingSurgeryChange(null)
    setShowWarningModal(false)
  }

  return (
    <>
      <div className="assign-step">
        <TrayCaseDetails onSurgeryChange={handleSurgeryChange} />
      </div>
      <div className="buttons_container">
        <Button variant="outlined" onClick={prevStep} fullWidth>
          Back
        </Button>
        <LoadingButton variant="contained" onClick={nextStep} fullWidth>
          {traySurgeryId ? 'Next' : 'Skip'}
        </LoadingButton>
      </div>

      {/* Warning Modal */}
      <Modal open={showWarningModal} onClose={cancelSurgeryChange}>
        <div
          className="surgery-change-warning-modal"
          style={{ backgroundColor: 'var(--primary-light)', borderRadius: 8 }}
        >
          <Typography variant="h5">Update Surgery for All Trays</Typography>
          <Typography variant="body1">
            Changing the selected surgery will update it for all trays being
            added. Do you want to continue?
          </Typography>
          <div className="modal-buttons">
            <Button variant="outlined" onClick={cancelSurgeryChange}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={confirmSurgeryChange}
            >
              Update All Trays
            </Button>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default AssignStep
